/* eslint-disable max-lines */

import {GaiaRed} from '@gaia/colors';
import {isGaiaColorHex} from '@gaia/utils/typing';
import mapValues from 'lodash/mapValues';

import airport from './airport.svg';
import attraction from './attraction.svg';
import beach from './beach.svg';
import bear from './bear.svg';
import bicycle from './bicycle.svg';
import binoculars from './binoculars.svg';
import bird from './bird.svg';
import bodyOfWater from './body-of-water.svg';
import bridge from './bridge.svg';
import building from './building.svg';
import bus from './bus.svg';
import cafe from './cafe.svg';
import cairn from './cairn.svg';
import camera from './camera.svg';
import campsite from './campsite.svg';
import canoe from './canoe.svg';
import car from './car.svg';
import cave from './cave.svg';
import cemetery from './cemetery.svg';
import chemist from './chemist.svg';
import circle from './circle.svg';
import city from './city.svg';
import cliff from './cliff.svg';
import climbing from './climbing.svg';
import dam from './dam.svg';
import danger from './danger.svg';
import deer from './deer.svg';
import disability from './disability.svg';
import discGolf from './disc-golf.svg';
import dogPark from './dog-park.svg';
import electric from './electric.svg';
import elk from './elk.svg';
import emergencyTelephone from './emergency-telephone.svg';
import fastFood from './fast-food.svg';
import fence from './fence.svg';
import fireLookout from './fire-lookout.svg';
import fireStation from './fire-station.svg';
import fish from './fish.svg';
import forest from './forest.svg';
import fuel from './fuel.svg';
import garden from './garden.svg';
import gate from './gate.svg';
import geyser from './geyser.svg';
import ghostTown from './ghost-town.svg';
import golf from './golf.svg';
import grass from './grass.svg';
import groundBlind from './ground-blind.svg';
import harbor from './harbor.svg';
import heart from './heart.svg';
import helipad from './helipad.svg';
import heliport from './heliport.svg';
import horse from './horse.svg';
import hospital from './hospital.svg';
import hotspring from './hotspring.svg';
import information from './information.svg';
import knownRoute from './known-route.svg';
import lake from './lake.svg';
import lighthouse from './lighthouse.svg';
import lodging from './lodging.svg';
import logging from './logging.svg';
import market from './market.svg';
import marsh from './marsh.svg';
import mine from './mine.svg';
import minefield from './minefield.svg';
import mobilephone from './mobilephone.svg';
import moose from './moose.svg';
import mud from './mud.svg';
import museum from './museum.svg';
import mushroom from './mushroom.svg';
import naturalSpring from './natural-spring.svg';
import noAdmittance1 from './no-admittance-1.svg';
import noAdmittance2 from './no-admittance-2.svg';
import number0 from './number-0.svg';
import number1 from './number-1.svg';
import number2 from './number-2.svg';
import number3 from './number-3.svg';
import number4 from './number-4.svg';
import number5 from './number-5.svg';
import number6 from './number-6.svg';
import number7 from './number-7.svg';
import number8 from './number-8.svg';
import number9 from './number-9.svg';
import offRoad from './off-road.svg';
import oilWell from './oil-well.svg';
import park from './park.svg';
import parking from './parking.svg';
import peak from './peak.svg';
import petroglyph from './petroglyph.svg';
import picnic from './picnic.svg';
import pin from './pin.svg';
import pitch from './pitch.svg';
import playground from './playground.svg';
import police from './police.svg';
import pollingPlace from './polling-place.svg';
import potableWater from './potable-water.svg';
import prison from './prison.svg';
import rail from './rail.svg';
import railroad from './railroad.svg';
import rangerStation from './ranger-station.svg';
import reef from './reef.svg';
import restaurant from './restaurant.svg';
import resupply from './resupply.svg';
import ruins from './ruins.svg';
import rvPark from './rv-park.svg';
import saddle from './saddle.svg';
import sandDune from './sand-dune.svg';
import scat from './scat.svg';
import scrub from './scrub.svg';
import shelter from './shelter.svg';
import shower from './shower.svg';
import skiing from './skiing.svg';
import snowflake from './snowflake.svg';
import snowmobile from './snowmobile.svg';
import square from './square.svg';
import star from './star.svg';
import steps from './steps.svg';
import stone from './stone.svg';
import suitcase from './suitcase.svg';
import swimming from './swimming.svg';
import toilets from './toilets.svg';
import trackDeer from './track-deer.svg';
import trackDog from './track-dog.svg';
import trailCamera from './trail-camera.svg';
import trailhead from './trailhead.svg';
import trash from './trash.svg';
import treeFall from './tree-fall.svg';
import treeStand from './tree-stand.svg';
import triangle from './triangle.svg';
import turkey from './turkey.svg';
import volcano from './volcano.svg';
import water from './water.svg';
import waterDrop from './water-drop.svg';
import waterfall from './waterfall.svg';
import wetland from './wetland.svg';
import wood from './wood.svg';

export function getMarkerName(
    markerType: MarkerType,
    markerDecoration: string | undefined,
    markerColorStr: string
) {
    const markerColor: GaiaColorHex = isGaiaColorHex(markerColorStr) ? markerColorStr : GaiaRed;

    return `${markerType}.${markerDecoration}.${markerColor}`;
}

export const mapMarkerNameToSVG: Record<UnifiedMarkerName, string> = {
    'body-of-water': bodyOfWater,
    'disc-golf': discGolf,
    'dog-park': dogPark,
    'emergency-telephone': emergencyTelephone,
    'fast-food': fastFood,
    'fire-lookout': fireLookout,
    'fire-station': fireStation,
    'ghost-town': ghostTown,
    'ground-blind': groundBlind,
    'known-route': knownRoute,
    'natural-spring': naturalSpring,
    'no-admittance-1': noAdmittance1,
    'no-admittance-2': noAdmittance2,
    'number-0': number0,
    'number-1': number1,
    'number-2': number2,
    'number-3': number3,
    'number-4': number4,
    'number-5': number5,
    'number-6': number6,
    'number-7': number7,
    'number-8': number8,
    'number-9': number9,
    'off-road': offRoad,
    'oil-well': oilWell,
    'polling-place': pollingPlace,
    'potable-water': potableWater,
    'ranger-station': rangerStation,
    'rv-park': rvPark,
    'sand-dune': sandDune,
    'track-deer': trackDeer,
    'track-dog': trackDog,
    'trail-camera': trailCamera,
    'tree-fall': treeFall,
    'tree-stand': treeStand,
    airport,
    attraction,
    beach,
    bear,
    bicycle,
    binoculars,
    bird,
    bridge,
    building,
    bus,
    cafe,
    cairn,
    camera,
    campsite,
    canoe,
    car,
    cave,
    cemetery,
    chemist,
    circle,
    city,
    cliff,
    climbing,
    dam,
    danger,
    deer,
    disability,
    electric,
    elk,
    fence,
    fish,
    forest,
    fuel,
    garden,
    gate,
    geyser,
    golf,
    grass,
    harbor,
    heart,
    helipad,
    heliport,
    horse,
    hospital,
    hotspring,
    information,
    lake,
    lighthouse,
    lodging,
    logging,
    market,
    marsh,
    mine,
    minefield,
    mobilephone,
    moose,
    mud,
    museum,
    mushroom,
    park,
    parking,
    peak,
    petroglyph,
    picnic,
    pin,
    pitch,
    playground,
    police,
    prison,
    rail,
    railroad,
    reef,
    restaurant,
    resupply,
    ruins,
    saddle,
    scat,
    scrub,
    shelter,
    shower,
    skiing,
    snowflake,
    snowmobile,
    square,
    star,
    steps,
    stone,
    suitcase,
    swimming,
    toilets,
    trailhead,
    trash,
    triangle,
    turkey,
    volcano,
    water: waterDrop,
    waterfall,
    wetland,
    wood,
};

export function assertUnifiedMarkerName(
    markerName: string
): asserts markerName is UnifiedMarkerName {
    if (!Object.keys(mapMarkerNameToSVG).includes(markerName)) {
        throw new Error(`Unrecognized marker name: ${markerName}`);
    }
}

export function isUnifiedMarkerName(iconName: string): iconName is UnifiedMarkerName {
    return Object.keys(mapMarkerNameToSVG).includes(iconName);
}

export function isMarkerDecoration(markerDecoration: string): markerDecoration is MarkerDecoration {
    if (markerDecoration.startsWith('emoji-') && markerDecoration.length > 'emoji-'.length) {
        return true;
    }
    if (isUnifiedMarkerName(markerDecoration)) return true;
    return false;
}

export function assertMarkerDecoration(
    markerDecoration: string
): asserts markerDecoration is MarkerDecoration {
    if (!isMarkerDecoration(markerDecoration)) {
        throw new Error(`Invalid marker decoration: ${markerDecoration}`);
    }
}

// There are two cases in which icons can be consumed by the UI:
// 1) Selecting an icon, e.g. from a picker. In this case only the icon and its display name are surfaced.
// 2) Displaying an icon on the map or in a component. In this case we need to be able to support legacy name
// variants. For example, red-pin-down.png and red-pin-down should both resolve to the same image component.
// In order to resolve these two cases, we provide two structures: `iconDisplayNames`, which is used when only the display name is relevant,
// and `allIcons`, for when the UI needs to be able to lookup an icon by multiple names.

// Note: Key order matches the order in which icons are displayed on mobile.
const iconDisplayNames: Record<UnifiedMarkerName | string, string> = {
    'airport-24': airport,
    'bicycle-24': bicycle,
    'building-24': building,
    'cafe-24': cafe,
    'camera-24': camera,
    'campsite-24': campsite,
    'car-24': car,
    'cemetery-24': cemetery,
    'chemist-24': chemist,
    'circle-24': circle,
    'city-24': city,
    'dam-24': dam,
    'danger-24': danger,
    'disability-24': disability,
    'disc-golf': discGolf,
    'dog-park-24': dogPark,
    'emergency-telephone-24': emergencyTelephone,
    'fast-food-24': fastFood,
    'fire-lookout': fireLookout,
    'fire-station-24': fireStation,
    'fuel-24': fuel,
    'garden-24': garden,
    'ghost-town': ghostTown,
    'golf-24': golf,
    'ground-blind': groundBlind,
    'harbor-24': harbor,
    'heart-24': heart,
    'heliport-24': heliport,
    'hospital-24': hospital,
    'known-route': knownRoute,
    'lighthouse-24': lighthouse,
    'lodging-24': lodging,
    'logging-24': logging,
    'minefield-24': minefield,
    'mobilephone-24': mobilephone,
    'natural-spring': naturalSpring,
    'no-admittance-1': noAdmittance1,
    'no-admittance-2': noAdmittance2,
    'number-0': number0,
    'number-1': number1,
    'number-2': number2,
    'number-3': number3,
    'number-4': number4,
    'number-5': number5,
    'number-6': number6,
    'number-7': number7,
    'number-8': number8,
    'number-9': number9,
    'off-road': offRoad,
    'oil-well-24': oilWell,
    'park-24': park,
    'parking-24': parking,
    'pitch-24': pitch,
    'playground-24': playground,
    'polling-place-24': pollingPlace,
    'potable-water': potableWater,
    'prison-24': prison,
    'rail-24': rail,
    'ranger-station': rangerStation,
    'restaurant-24': restaurant,
    'rv-park': rvPark,
    'sand-dune': sandDune,
    'skiing-24': skiing,
    'square-24': square,
    'star-24': star,
    'suitcase-24': suitcase,
    'swimming-24': swimming,
    'toilets-24': toilets,
    'track-deer': trackDeer,
    'track-dog': trackDog,
    'trail-camera': trailCamera,
    'tree-fall': treeFall,
    'tree-stand': treeStand,
    'triangle-24': triangle,
    'water-24': waterDrop,
    'wetland-24': wetland,
    attraction,
    beach,
    bear,
    binoculars,
    bird,
    bridge,
    bus,
    cairn,
    canoe,
    cave,
    cliff,
    climbing,
    deer,
    electric,
    elk,
    fence,
    fish,
    forest,
    gate,
    geyser,
    grass,
    helipad,
    horse,
    hotspring,
    information,
    lake,
    market,
    marsh,
    mine,
    moose,
    mud,
    museum,
    mushroom,
    peak,
    petroglyph,
    picnic,
    police,
    railroad,
    reef,
    resupply,
    ruins,
    saddle,
    scat,
    scrub,
    shelter,
    shower,
    snowflake,
    snowmobile,
    steps,
    stone,
    trailhead,
    trash,
    turkey,
    volcano,
    water,
    waterfall,
    wood,
};

// Map all known icon name variants to their correct key
const allIconNames: Record<string, keyof typeof iconDisplayNames> = {
    fireLookout: 'fire-lookout',
    'airport-24.png': 'airport-24',
    'beach.png': 'beach',
    'bicycle-24.png': 'bicycle-24',
    'building-24.png': 'building-24',
    'cafe-24.png': 'cafe-24',
    'camera-24.png': 'camera-24',
    'campsite-24.png': 'campsite-24',
    'car-24.png': 'car-24',
    'cemetery-24.png': 'cemetery-24',
    'chemist-24.png': 'chemist-24',
    'circle-24.png': 'circle-24',
    'city-24.png': 'city-24',
    'dam-24.png': 'dam-24',
    'danger-24.png': 'danger-24',
    'disability-24.png': 'disability-24',
    'dog-park-24.png': 'dog-park-24',
    'emergency-telephone-24.png': 'emergency-telephone-24',
    'fast-food-24.png': 'fast-food-24',
    'fire-station-24.png': 'fire-station-24',
    'fuel-24.png': 'fuel-24',
    'garden-24.png': 'garden-24',
    'golf-24.png': 'golf-24',
    'harbor-24.png': 'harbor-24',
    'heart-24.png': 'heart-24',
    'heliport-24.png': 'heliport-24',
    'hospital-24.png': 'hospital-24',
    'lighthouse-24.png': 'lighthouse-24',
    'lodging-24.png': 'lodging-24',
    'logging-24.png': 'logging-24',
    'minefield-24.png': 'minefield-24',
    'mobilephone-24.png': 'mobilephone-24',
    'oil-well-24.png': 'oil-well-24',
    'park-24.png': 'park-24',
    'parking-24.png': 'parking-24',
    'pitch-24.png': 'pitch-24',
    'playground-24.png': 'playground-24',
    'polling-place-24.png': 'polling-place-24',
    'prison-24.png': 'prison-24',
    'rail-24.png': 'rail-24',
    'restaurant-24.png': 'restaurant-24',
    'skiing-24.png': 'skiing-24',
    'square-24.png': 'square-24',
    'star-24.png': 'star-24',
    'suitcase-24.png': 'suitcase-24',
    'swimming-24.png': 'swimming-24',
    'toilets-24.png': 'toilets-24',
    'triangle-24.png': 'triangle-24',
    'water-24.png': 'water-24',
    'wetland-24.png': 'wetland-24',
    ...mapValues(iconDisplayNames, (value, key: keyof typeof iconDisplayNames) => key),
};

export const allIcons = mapValues(allIconNames, (value) => iconDisplayNames[value]);

export default iconDisplayNames;

export {
    airport,
    attraction,
    beach,
    bear,
    bicycle,
    binoculars,
    bird,
    bodyOfWater,
    bridge,
    building,
    bus,
    cafe,
    cairn,
    camera,
    campsite,
    canoe,
    car,
    cave,
    cemetery,
    chemist,
    circle,
    city,
    cliff,
    climbing,
    dam,
    danger,
    deer,
    disability,
    discGolf,
    dogPark,
    electric,
    elk,
    emergencyTelephone,
    fastFood,
    fence,
    fireLookout,
    fireStation,
    fish,
    forest,
    fuel,
    garden,
    gate,
    geyser,
    ghostTown,
    golf,
    grass,
    groundBlind,
    harbor,
    heart,
    helipad,
    heliport,
    horse,
    hospital,
    hotspring,
    information,
    knownRoute,
    lake,
    lighthouse,
    lodging,
    logging,
    market,
    marsh,
    mine,
    minefield,
    mobilephone,
    moose,
    mud,
    museum,
    mushroom,
    naturalSpring,
    noAdmittance1,
    noAdmittance2,
    number0,
    number1,
    number2,
    number3,
    number4,
    number5,
    number6,
    number7,
    number8,
    number9,
    offRoad,
    oilWell,
    park,
    parking,
    peak,
    petroglyph,
    picnic,
    pin,
    pitch,
    playground,
    police,
    pollingPlace,
    potableWater,
    prison,
    rail,
    railroad,
    rangerStation,
    reef,
    restaurant,
    resupply,
    ruins,
    rvPark,
    saddle,
    sandDune,
    scat,
    scrub,
    shelter,
    shower,
    skiing,
    snowflake,
    snowmobile,
    square,
    star,
    steps,
    stone,
    suitcase,
    swimming,
    toilets,
    trackDeer,
    trackDog,
    trailCamera,
    trailhead,
    trash,
    treeFall,
    treeStand,
    triangle,
    turkey,
    volcano,
    water,
    waterDrop,
    waterfall,
    wetland,
    wood,
};
